import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet
} from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import { AuthContext, useAuth } from './AuthContext';

import Login from './Login';
import Homepage from './Homepage';
import ReportItem from './ReportItem';
import ItemDetailsPage from './ItemDetailsPage';
import AllLostItems from './AllLostItems';
import AllFoundItems from './AllFoundItems';
import UserDashboard from './UserDashboard';
import HistoryPage from './HistoryPage';
// ✅ ADD THIS: Import AdminDashboard component
import AdminDashboard from './AdminDashboard';

function Loader() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 24
    }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}

function ProtectedRoute() {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  return user ? <Outlet /> : <Navigate to="/login" replace />;
}

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, firebaseUser => {
      setUser(firebaseUser);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const authContextValue = { user, loading };

  return (
    <div>
      <AuthContext.Provider value={authContextValue}>
        <Router>
          <Routes>
            {/* Public Route */}
            <Route path="/login" element={<Login />} />

            {/* Protected Routes */}
            <Route element={<ProtectedRoute />}>
              {/* Homepage as index */}
              <Route index element={<Homepage />} />

              {/* Other authenticated pages */}
              <Route path="reportitem" element={<ReportItem />} />
              <Route path="itemdetails/:id" element={<ItemDetailsPage />} />
              <Route path="all-lost-items" element={<AllLostItems />} />
              <Route path="all-found-items" element={<AllFoundItems />} />
              <Route path="dashboard" element={<UserDashboard />} />
              <Route path="history" element={<HistoryPage />} />
              
              {/* ✅ CRITICAL FIX: Add Admin Dashboard Route */}
              <Route path="admin/dashboard" element={<AdminDashboard />} />

              {/* Catch-all for authenticated users */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>

            {/* Fallback for unauthenticated or unknown */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </AuthContext.Provider>
    </div>
  );
}
